import { getViemClients, } from "@bracket/contractor-next";
import type { Config } from "@wagmi/core";

import {
	getContractWithABI,
	isAddress,
	isBlockHash,
	type BlockHash,
	type ValidChainId,
} from "@bracket/chainography";




export declare type ClaimBrktTvlFeesProps = {
	/** Address for the subject vault */
	vault: string;
	chainId?: ValidChainId;
	config?: Config;
};


export const claimBrktTvlFees = async ({
	vault,
	chainId = 1,
	config,
}: ClaimBrktTvlFeesProps): Promise<BlockHash> => {
	try {

		if(!isAddress(vault))
			throw new Error("invalid vault address provided.");

		const [client, walletClient] = await getViemClients({ chainId, config, });
		const [__, abi] = getContractWithABI("BracketVault");

		// const tok = getTokenDefinition("BRKTETH");
		// const approved = await assertAllowance({ amount, spender: vault, token: tok.address, });
		// if(!approved)
		// 	throw new Error(`failed gaining approval for spending ${amount} ${symbol} at ${tokAddress}`);
		
		const {
			request,
			result,
		} = await client.simulateContract({
			address: vault,
			abi,
			functionName: "claimBrktTvlFees",
			account: walletClient.account,
		})

		const hash = await walletClient.writeContract(request);
		await client.waitForTransactionReceipt({ hash, timeout: 60_000, });
		if(isBlockHash(hash)) {
			return hash;
		}

		throw new Error("claimBrktTvlFees failed to produce a valid request");

	}
	catch (err) {

		throw new Error(`@bracket/chainography/BracketVault:claimBrktTvlFees failed - ${err.message}`);
	}

};
